import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";

import { isBigger } from "store/actions/device";
import { setOpenMenu } from "store/actions/menu";

import Drawer from "@mui/material/Drawer";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";

import { WrapMenu, Icon } from "components/template/menu/theme";

export const EMPLOYEE_ROUTES = [
  { label: "Dashboard", url: "/employee-portal", icon: "dashboard" },
  { label: "Presenze", url: "/employee-portal/attendance", icon: "timelog" },
  { label: "Attività", url: "/employee-portal/activities", icon: "report" },
];

const getMenuType = (device) => (isBigger(device, "md") ? "persistent" : "temporary");

function EmployeeMenu({ device, isOpen, setOpenMenu }) {
  const menuType = getMenuType(device);
  const lastMenuType = useRef(menuType);

  /** CAMBIA LA MODALITA' DEL MENU IN BASE ALLA RISOLUZIONE DELLO SCHERMO */
  useEffect(() => {
    if (lastMenuType.current === menuType) return;
    lastMenuType.current = menuType;
    setOpenMenu(menuType === "persistent");
  }, [menuType, setOpenMenu]);

  const closeTemporaryMenu = () => {
    if (menuType === "temporary") setOpenMenu(false);
  };

  return (
    <WrapMenu>
      <div className={`os-wrap-menu ${isOpen ? "menu-open" : "menu-close"}`}>
        <Drawer
          className="os-drawer"
          variant={menuType}
          anchor="left"
          open={isOpen}
          onClose={() => setOpenMenu(false)}
        >
          {EMPLOYEE_ROUTES.map((route, i) => (
            <React.Fragment key={route.url}>
              {i > 0 && <Divider />}
              <ListItem component={Link} to={route.url} onClick={closeTemporaryMenu}>
                <ListItemIcon>
                  <Icon src={`/assets/icons/${route.icon}.svg`} alt="" />
                </ListItemIcon>
                <ListItemText secondary={route.label} />
              </ListItem>
            </React.Fragment>
          ))}
        </Drawer>
      </div>
    </WrapMenu>
  );
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.menu.isOpen,
    device: state.device.type,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setOpenMenu: bindActionCreators(setOpenMenu, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeMenu);
